import { ColumnDef } from "@tanstack/react-table";
import _, { isUndefined } from "lodash";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/Header";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { LifeData, LifeDataMaintenance } from "../../../types/formDataTypes";
import { EquipmentChange, Maintenance } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { SimpleDataTable } from "../../../ui/DataTable/SimpleDataTable";
import { Input } from "../../../ui/Input/Input";
import { Separator } from "../../../ui/Separator";
import { ToggleGroup, ToggleGroupItem } from "../../../ui/ToggleGroup/ToggleGroup";
import MaintenancesFilters from "./MaintenancesFilters";
import MaintenanceSorting from "./MaintenanceSorting";
import MaintenanceTimeline from "./MaintenanceTimeline/MaintenanceTimeline";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/Tabs/Tabs";
import { ServiceTable } from "./ServiceTable/ServiceTable";
import Spinner from "../../../ui/Spinner/Spinner";
import { changesTypes } from "../../../enums";
import RepairTimeline from "./RepairTimeline/RepairTimeline";

// type Props = {};

// export type MaintenancesFilterType = {
//   producers: Array<string>;
//   equipment_type: Array<string>;
//   maintenance_type: Array<string>;
// };

// export type MaintenancesSortingType = {
//   date: undefined | boolean;
//   time: undefined | boolean;
// };

// export type MaintenancesCategoriesType = {
//   unique_equipment_type_name: Array<string>;
//   unique_producer_name: Array<string>;
//   unique_maintenance_type: Array<string>;
// };

// //Сортировачные функции
// function compareLuxonDates(a: MaintenancesPageTableData, b: MaintenancesPageTableData) {
//   return a.start.toMillis() - b.start.toMillis();
// }

// function compareMaintenanceTime(a: MaintenancesPageTableData, b: MaintenancesPageTableData) {
//   return a.rest_operating_time - b.rest_operating_time;
// }

export const Maintenances = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const {equipments, currentSite} = useAppStore();
  const [lifeParams, setLifeParams] = useState(new URLSearchParams({}));
  const [life, setLife] = useState<LifeData[]>()
  const [services, setServices] = useState<LifeDataMaintenance[]>()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState<"table" | "calendar">("calendar")
  const [maintenances, setMaintenances] = useState<Maintenance[]>([]);
  const [{ response, isLoading, error }, doFetchMaintenances] = useFetch(`/directories/maintenances`);
  const [{ response: lifeResponse, isLoading: lisIsLoading, error: lifeError}, doFetchLife] = useFetch(`/directories/equipment_items/changes/filter?${lifeParams}`);
  

  useEffect(() => {
    setLoading(true);
    setParamsForLife()
    doFetchMaintenances();
  }, []);

  function setParamsForLife() {
    let newLifeParams = new URLSearchParams({});
    equipments?.map(eq => {
      newLifeParams.append("equipment_item_ids[]", eq.id)
    })
    newLifeParams.append("types[]", "Sites::EquipmentItemChanges::Status");

    setLifeParams(newLifeParams)
  }

  useEffect(() => {
    if (!response) {
      return;
    }
    let maintenancesResponse = response.data as unknown as Maintenance[];

    let data = maintenancesResponse?.map((data, index) => {
      let eq = equipments?.find(e => Number(e.id) === data.attributes.equipment_item_id)!
      return {
        id: `mt_${data.id}_${index}`,
        group: "maintenance",
        type: data.attributes.maintenance_type,
        name: data.attributes.description, // name
        description: data.attributes.maintenance_description,
        equipment_item_id: data.attributes.equipment_item_id,
        equipment_name: eq?.attributes.name,
        equipment_inventory_number: eq?.attributes.inventory_number,
        start: DateTime.fromISO(data.attributes.next_maintenance_at).startOf("day"),
        end: DateTime.fromISO(data.attributes.next_maintenance_at).endOf("day"),
        data: {
          operating_time: data.attributes.maintenance_time,
          rest_operating_time: data.attributes.maintenance_time - data.attributes.next_maintenance_after,
          previous_service_at: DateTime.fromISO(data.attributes.previous_maintenance_at),
          expired: data.attributes.expired
        }
      };
    });
    setServices(data)
    doFetchLife()
  }, [response]);

  useEffect(() => {
    if (!lifeResponse) {
      return;
    }
    let response = lifeResponse.data as unknown as EquipmentChange[]
    let lifecycle: any[] = []
    Object.entries(_.groupBy(response.map(i => ({...i.attributes, id: i.id})), "equipment_item_id")).map(([eid, data]) => {
      let ordered = _.orderBy(data, "at")
      
      ordered.map((ch, index) => {
        let eq = equipments?.find(e => Number(e.id) === ch.equipment_item_id)!
        lifecycle.push({
          id: `ch_${ch.id}_${index}`,
          group: "lifecycle",
          type: ch.status,
          name: ch.status, // name
          description: ch.description,
          equipment_item_id: ch.equipment_item_id,
          equipment_name: eq?.attributes.name,
          equipment_inventory_number: eq?.attributes.inventory_number,
          start: DateTime.fromISO(ch.at),
          end: isUndefined(ordered[index + 1]) ? DateTime.local() : DateTime.fromISO(ordered[index + 1].at),
        })
      })
    })
    setLife(lifecycle);
    setLoading(false);
  }, [lifeResponse]);


  return (
    <div className="flex flex-col w-full h-full bg-muted">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span>
          </NavLink>
          <span>/</span>
          <NavLink to={"/managment"}>
            <span className="font-medium">{t("managment")}</span>
          </NavLink>
          <span>/</span>
          {location.pathname == "/managment/maintenance/" || location.pathname == "/managment/maintenance" ? (
            <span className="font-medium">{t("repair_and_service")}</span>
          ) : (
            <NavLink to={"/managment/maintenance"}>
              <span className="font-medium">{t("repair_and_service")}</span>
            </NavLink>
          )}
          {(id || location.pathname == "/managment/maintenance/new") && <span>/</span>}
          {id && <span>{}</span>}
          {location.pathname == "/managment/maintenance/new" && <span>{t("adding_service")}</span>}
        </div>
      </div>
      <Separator className="flex-none" />
      {loading ? (
        <Spinner />
      ) : (
        <div className="flex w-full h-full bg-background">
          <div className="flex flex-col w-full h-full mx-auto">
            <Header name={t("repair_and_service")} backName={t("managment")} backLink={"/managment"} />
            <Tabs defaultValue="monitoring" className="flex flex-col h-full overflow-hidden">
              <div className="flex-none px-6">
                <TabsList className="w-full justify-start">
                  <TabsTrigger value="monitoring">{t("monitoring")}</TabsTrigger>
                  <TabsTrigger value="repair">{t("repair")}</TabsTrigger>
                  <TabsTrigger value="service">{t("service")}</TabsTrigger>
                  <TabsTrigger value="network">{t("network")}</TabsTrigger>
                </TabsList>
              </div>
              <TabsContent value="monitoring" className="flex flex-col w-full data-[state=active]:h-full m-0">
                <MaintenanceTimeline data={[...life!, ...services!]} />
              </TabsContent>
              <TabsContent value="repair" className="flex flex-col w-full data-[state=active]:h-full m-0">
                <RepairTimeline data={[...life!, ...services!]} />
              </TabsContent>
              <TabsContent value="service">
                <ServiceTable nodes={services!} maintenances={maintenances} />
              </TabsContent>
              <TabsContent value="network"></TabsContent>
            </Tabs>
          </div>
        </div>
      )}
    </div>
  );
};
